



















































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import SumupDetailTab from "../../components/SumupDetailTab.vue"
import { BModal, BCarousel } from 'bootstrap-vue';
import { SumupGroup, SumupTotalAll, SumupPart1All, SumupFieldAll } from "../../modules/teacher/PracticeSumupDetailCurriculum"


export interface Data {
  sumup_group_id: string
  curriculum_id: string
  sumupGroup: SumupGroup
  sumupTotalAll: SumupTotalAll
  sumupPart1Alls: SumupPart1All[]
  sumupFieldAlls: SumupFieldAll[]
  perFroms: number[]
  perTos: number[]
  errors: string[]
}

export default defineComponent({
  components: {
    "sumup-detail-tab": SumupDetailTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sumup_group_id: null,
      curriculum_id: null,
      sumupGroup: null,
      sumupTotalAll: null,
      sumupPart1Alls: [],
      sumupFieldAlls: [],
      perFroms: [91, 81, 71, 61, 51, 41, 31, 21, 11, 0],
      perTos: [100, 90, 80, 70, 60, 50, 40, 30, 20, 10],
      errors: [],
    });

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      state.curriculum_id = context.root.$route.params.curriculum_id;
      await http.get(`/api/teacher/practice_sumup_detail_curriculum?sumup_group_id=${state.sumup_group_id}&curriculum_id=${state.curriculum_id}`).then(response => {
        state.sumupGroup = new SumupGroup(response.data.sumup_group);
        state.sumupTotalAll = new SumupTotalAll(response.data.sumup_total_all);
        state.sumupPart1Alls = response.data.sumup_part1_alls.map((x: any) => new SumupPart1All(x));
        state.sumupFieldAlls = response.data.sumup_field_alls.map((x: any) => new SumupFieldAll(x));
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "-";
    };

    
    return {
      ...toRefs(state),
      modalRef,
      carouselRef,
      convertExecDate,
    };
  }
});

